var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('LoginForm',{attrs:{"signingIn":_vm.signingIn},on:{"login":_vm.signin,"createAnAccountButton":_vm.createAnAccountButton}}),_c('SnackbarNotifier',{attrs:{"isShow":_vm.isShowSnackBar,"message":_vm.responseMessage,"snackType":_vm.snackbarType,"colour":_vm.snackBarColour},on:{"eReset":_vm.resetSnackBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }